// extracted by mini-css-extract-plugin
export default {"icon":"D7TPLR9fCDYQE80p3KHK"};